import { c as _c } from "react/compiler-runtime";
export const BurgerIcon = t0 => {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <rect width="28" height="2.4" fill="currentColor" />;
    t2 = <rect y="8.7998" width="28" height="2.4" fill="currentColor" />;
    t3 = <rect y="17.6001" width="28" height="2.4" fill="currentColor" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = <svg className={className} width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">{t1}{t2}{t3}</svg>;
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};